import { Pipe, PipeTransform } from '@angular/core';

const UC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LC = 'abcdefghijklmnopqrstuvwxyz';
const boldUpper = Array.from('𝗔𝗕𝗖𝗗𝗘𝗙𝗚𝗛𝗜𝗝𝗞𝗟𝗠𝗡𝗢𝗣𝗤𝗥𝗦𝗧𝗨𝗩𝗪𝗫𝗬𝗭');
const boldLower = Array.from('𝗮𝗯𝗰𝗱𝗲𝗳𝗴𝗵𝗶𝗷𝗸𝗹𝗺𝗻𝗼𝗽𝗾𝗿𝘀𝘁𝘂𝘃𝘄𝘅𝘆𝘇');
const italicUpper = Array.from('𝘈𝘉𝘊𝘋𝘌𝘍𝘎𝘏𝘐𝘑𝘒𝘓𝘔𝘕𝘖𝘗𝘘𝘙𝘚𝘛𝘜𝘝𝘞𝘟𝘠𝘡');
const italicLower = Array.from('𝘢𝘣𝘤𝘥𝘦𝘧𝘨𝘩𝘪𝘫𝘬𝘭𝘮𝘯𝘰𝘱𝘲𝘳𝘴𝘵𝘶𝘷𝘸𝘹𝘺𝘻');

@Pipe({ name: 'unicodeBold', standalone: true, pure: true })
export class UnicodeBoldPipe implements PipeTransform {
  transform(text: string): string {
    return Array.from(text)
      .map((c) => boldUpper[UC.indexOf(c)] ?? boldLower[LC.indexOf(c)] ?? c)
      .join('');
  }
}

@Pipe({ name: 'unicodeItalic', standalone: true, pure: true })
export class UnicodeItalicPipe implements PipeTransform {
  transform(text: string): string {
    return Array.from(text)
      .map((c) => italicUpper[UC.indexOf(c)] ?? italicLower[LC.indexOf(c)] ?? c)
      .join('');
  }
}
